export type AudioRange = { start: number; end: number };
/** A browser/provider playback window, never an ATC wall-clock synchronization claim. */
export function audioWindow(audio: Pick<HTMLMediaElement, 'seekable' | 'currentTime'> | null) {
 const ranges: AudioRange[]=[];
 if(audio)try{
  for(let i=0;i<Math.min(audio.seekable.length,128);i++){
   const start=audio.seekable.start(i),end=audio.seekable.end(i);
   if(Number.isFinite(start)&&Number.isFinite(end)&&start>=0&&end>start)ranges.push({start,end});
  }
 }catch{/* Seekable ranges can expire while a live source advances. */}
 const edge=ranges.length?Math.max(...ranges.map(r=>r.end)):null;
 return {ranges,edge,behindSeconds:edge!==null&&Number.isFinite(audio?.currentTime)?Math.max(0,edge-audio!.currentTime):0};
}
/** Clamp to actual earlier playable audio; never seek forward across a missing segment. */
export function replayTarget(current: number, ranges: AudioRange[], seconds: number): number|null {
 if(!Number.isFinite(current)||!Number.isFinite(seconds)||seconds<=0)return null;
 const desired=current-seconds;
 let target:number|null=null;
 for(const {start,end} of ranges){
  if(!Number.isFinite(start)||!Number.isFinite(end)||start<0||end<=start||start>=current-.05)continue;
  const candidate=Math.min(Math.max(desired,start),end-.01,current-.05);
  if(candidate<start)continue;
  if(desired>=start&&desired<end)return candidate;
  // Prefer the nearest earlier range; fall back to the start of the available window.
  if(end<=desired){if(target===null||target<start||candidate>target)target=candidate;}
  else if(target===null||target>desired&&candidate<target)target=candidate;
 }
 return target;
}
